import { all, takeEvery, put, fork } from "redux-saga/effects";
import * as actionTypes from "../actions/actionTypes";
import * as actions from "../actions/index";
import * as API from "../api";

export function* sendMerchantInterestEmail() {
  yield takeEvery(actionTypes.SEND_MERCHANT_INTEREST_EMAIL, function*(action) {
    yield put(actions.enableLoading());

    // Verify verification code
    try {
      const response = yield API.sendMerchantInterestEmail(action.data);
      if (response.data.success) {
        yield put(actions.sendMerchantInterestEmailSuccess(response.data));
        alert(response.data.message);
      } else {
        yield put(actions.sendMerchantInterestEmailFail());
        alert(response.data.message);
      }
      yield put(actions.disableLoading());
    } catch (error) {
      alert(API.constructErrMsg(error));
      yield put(actions.sendMerchantInterestEmailFail());
      yield put(actions.disableLoading());
    }
  });
}

export default function* emailSaga() {
  yield all([fork(sendMerchantInterestEmail)]);
}
